import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "home" */ './AsyncHomeRoute.js'),
  loading: () => null
});
